import { playSound, Sound } from '~/assets/sounds';
import { StyledCircle, StyledRect, StyledSvg } from './Switch.styled';

interface ISwitchProps {
	value: boolean;
	onChange: (value: boolean) => void;
}

const Switch: React.FC<ISwitchProps> = ({ value, onChange }: ISwitchProps) => {
	return (
		<StyledSvg
			width="30"
			height="20"
			viewBox="0 0 30 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			onClick={() => {
				onChange(!value);
				playSound(Sound.ClickButton);
			}}
			onMouseEnter={() => playSound(Sound.LinkCursor)}
		>
			<StyledRect $active={value} width="30" height="20" rx="10" />
			<StyledCircle $active={value} cx="20" cy="10" r="5" />
		</StyledSvg>
	);
};

export { Switch };
